module.exports = __webpack_public_path__ + "img/1-5.c4a9bf43.svg";